"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmAcceptanceRequirement = void 0;
const studentdomain_1 = require("@studyportals/studentdomain");
const scholarship_requirement_type_1 = require("../types/scholarship-requirement-type");
class ConfirmAcceptanceRequirement {
    constructor(anonymousStudentService) {
        this.anonymousStudentService = anonymousStudentService;
        this.type = scholarship_requirement_type_1.ScholarshipRequirementType.CONFIRM_ACCEPTANCE;
    }
    isFulfilled() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.anonymousStudentService)
                return false;
            const data = yield this.anonymousStudentService.getStudentData([
                studentdomain_1.StudentField.SCHOLARSHIP_ACCEPTANCES
            ]);
            if (!data[studentdomain_1.StudentField.SCHOLARSHIP_ACCEPTANCES])
                return false;
            const isAnyAcceptanceFilledForThisYear = data[studentdomain_1.StudentField.SCHOLARSHIP_ACCEPTANCES].some((acceptance) => new Date(acceptance.timestamp_iso).getFullYear() === new Date().getFullYear());
            return isAnyAcceptanceFilledForThisYear;
        });
    }
}
exports.ConfirmAcceptanceRequirement = ConfirmAcceptanceRequirement;
